import type { FunctionComponent } from 'react'

import { useTranslation } from '../../contexts/localization/Localization'
import { CustomButton } from '../../components/ui/CustomButton'

/**
 * @deprecated use 'Connect to CRM' instead.
 */
const CreateCrmObjectWidget: FunctionComponent = () => {
  const { text: t } = useTranslation()

  return (
    <div>
      <CustomButton size="lg" disabled>
        {t('createCrmObjectWidget_defaultButton')}
      </CustomButton>
      <p>{<span className="text-sm text-gray-500">{t('createCrmObjectWidget_deprecated')}</span>}</p>
    </div>
  )
}

export default CreateCrmObjectWidget
